import type { Dispatch } from 'redux';
import {
    createActionFactory,
    Feature,
    createThunk,
    ThunkDispatch,
    DeletedPersona,
} from '../../../../shared';
import { hardDelete } from '../../data/hardDeleteDataActions';
import { getDisplayedItemHubPersonaIds } from '../../../selectors/personaListSelector';
import { HubState, packageStateKey } from './../../../state';
import { getPackageState } from '../../../../appstate';

export interface HardDeleteActionPayload {
    personas: DeletedPersona[];
    displayedHubPersonaIds: string[];
}
export const hardDeleteClickedAction = createActionFactory<void>(
    'HardDeleteClickedAction',
    Feature.HardDelete
);
export const confirmHardDeletePersonasClickedAction = createActionFactory<HardDeleteActionPayload>(
    'ConfirmHardDeletePersonasClickedAction',
    Feature.HardDelete,
    action => {
        return {
            items: action.payload.personas.length,
        };
    }
);
export const cancelHardDeletePersonasClickedAction = createActionFactory<void>(
    'CancelDeletePersonasClickedAction',
    Feature.HardDelete
);
export const dismissHardDeleteDialogAction = createActionFactory<void>(
    'DismissHardDeleteDialogAction',
    Feature.HardDelete
);

export const hardDeleteClicked = (dispatch: Dispatch) => () => dispatch(hardDeleteClickedAction());

export const confirmHardDeletePersonasClicked = (personas: DeletedPersona[]) =>
    createThunk(
        'ConfirmHardDeletePersonasClicked',
        (dispatch: ThunkDispatch, getState: () => {}): void => {
            const state = getPackageState<HubState>(getState(), packageStateKey);
            const displayedHubPersonaIds = getDisplayedItemHubPersonaIds(
                state.appState,
                state.packageState
            );
            const actionPayload: HardDeleteActionPayload = {
                personas,
                displayedHubPersonaIds,
            };
            dispatch(confirmHardDeletePersonasClickedAction(actionPayload));
            dispatch(hardDelete(actionPayload));
        }
    );

export const cancelHardDeletePersonasClicked = (dispatch: Dispatch) => () =>
    dispatch(cancelHardDeletePersonasClickedAction());
export const dismissHardDeleteDialog = (dispatch: Dispatch) => () =>
    dispatch(dismissHardDeleteDialogAction());
export type { Action } from '../../../../shared';
